export function handleClickOnAutomaticARRecipient(
  recipientId: string,
  profileTab?: string,
  newTabRedirect?: boolean
) {
  window.open(
    `/?name=customer.views.customer&form_name=view&id=${recipientId}&tab=${
      profileTab || 'account'
    }`,
    `${newTabRedirect ? '_blank' : '_self'}`
  );
}
